// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"b1a9f796","149":"2084e277","423":"5377defa","453":"825386d9","461":"37b88183","846":"7d58f347","879":"e7a06bcb"}[chunkId] + ".chunk.js";
};